import React from "react";
import { motion } from "framer-motion";
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrap";
// import { urlFor, client } from "../../client";
import LottieCard from "../../LottieCard";
import "./About.scss";

const About = () => {
  const abouts = [
    {
      title: "Full Stack Developer",
      description:
        "I'm a Full Stack Web2.0/3.0 MEReactN & MENextN Developer with strong hands on each aspects and worked on several projects",
      ImgUrl: "https://assets2.lottiefiles.com/packages/lf20_ne6kcqfz.json",
    },
    {
      title: "Front-End Developer",
      description:
        "I'm working on my front-end skills with practice and consistency it'll be becoming better",
      ImgUrl: "https://assets6.lottiefiles.com/packages/lf20_kyu7xb1v.json",
    },

    {
      title: "Back-End Developer",
      description:
        "I'm a back-end developer with a spark of making website functionally attractive",
      ImgUrl:
        "https://assets5.lottiefiles.com/private_files/lf30_wqypnpu5.json",
    },
    {
      title: "Blockchain Developer",
      description:
        "I had recently caught into WEB3.0 Environment and with 3 mega hackathons in hand",
      ImgUrl:
        "https://assets3.lottiefiles.com/packages/lf20_banmwpq1/data.json",
    },
    {
      title: "ML & AI Ethusiast",
      description:
        "I'm also into Machine Learning & Artificial Intelligence with basic projects and knowledge of it , looking forward to dive in",
      ImgUrl: "https://assets2.lottiefiles.com/private_files/lf30_WdTEui.json",
    },
  ];

  return (
    <>
      <h2 className="head-text">
        <span>Functionality </span>leads to<span> Opportunity</span>
      </h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <>
              <LottieCard width="100%" src={about.ImgUrl} />
            </>

            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg"
);
